import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { FirstShiftAppointmentStatusFeatureState } from '../interfaces/shared.interface';
import { FirstShiftAppointmentStatusAPIActions } from '../actions/first-shift-appointment-status.actions';

const initialState: FirstShiftAppointmentStatusFeatureState = {
  isLoaded: false,
  attendedDate: null,
};

const reducer: ActionReducer<FirstShiftAppointmentStatusFeatureState> =
  createReducer(
    initialState,
    on(
      FirstShiftAppointmentStatusAPIActions.loadedFirstShiftAppointmentStatusSuccessfully,
      (state, { attendedData }): FirstShiftAppointmentStatusFeatureState => ({
        ...state,
        attendedDate: attendedData?.attendedDate ?? '',
        isLoaded: true,
      }),
    ),
  );

export function firstShiftAppointmentStatusReducer(
  state: FirstShiftAppointmentStatusFeatureState = initialState,
  action: Action,
): FirstShiftAppointmentStatusFeatureState {
  return reducer(state, action);
}
